import IntegrationsAPI from '@/API/integrations-apis/IntegrationsAPI'
import IntegrationCategoriesAPI from '@/API/integrations-apis/IntegrationCategoriesAPI'
import CustomWhatsAppAPI from '@/API/integrations-apis/CustomWhatsAppAPI'

export default {
  namespaced: true,
  state: {
    allVendorsIntegrations: [],
    allVendorsIntegrationsFetched: false,
    categories: [],
    categoriesFetched: false,
    customWp: null,
    customWpFetched: false,
  },
  getters: {
    categories: (state: any) => state.categories,
    customWp: (state: any) => state.customWp,
    connections: (state: any, getters: any, rootState: any, rootGetters: any) => (rootGetters['branches/currentBranch']?.integrations ?? [])
      .filter((connection: any) => !connection.disabled && (connection.vendor_id || connection.config) && (!connection.integration?.regions?.length || connection.integration.regions.includes(rootGetters['branches/currentBranch'].country_iso))),
    integrations: (state: any, getters: any) => getters.connections.map((connection: any) => ({ ...connection.integration, connection })),
    isIntegrationCategoryPurchased: (state: any, getters: any, rootState: any, rootGetters: any) => (category: any) => (!category.addon?.slug && !category.packages?.length) || rootGetters['subscription/isAddonPurchased'](category.addon?.slug) || (category.packages ?? []).some((_package: any) => rootGetters['subscription/currentPackage']?.slug === _package.slug),
    isIntegrationPurchased: (state: any, getters: any, rootState: any, rootGetters: any) => (integration: any) => (!integration.addon?.slug) || rootGetters['subscription/isAddonPurchased'](integration.addon?.slug),
    deliveryIntegrations: (state: any, getters: any) => getters.integrations.filter((integration: any) => integration.category?.slug === 'delivery'),
    OrderedBranchConnections:
      (state: any, getters: any, rootState: any, rootGetters: any) => (branchId?: any) => {
        const branch = rootGetters['branches/selectedBranch'](branchId)
        const currentBranch = rootGetters['branches/selectedBranch'](branchId)
        return (branch?.integrations ?? []).filter((connection: any) => !connection.disabled && connection.integration?.category?.slug === 'delivery' && (connection.vendor_id || connection.config) && (!connection.integration?.regions?.length || connection.integration.regions.includes(currentBranch?.country_iso)))
      },
    OrderedBranchIntegrations: (state: any, getters: any) => (branchId?: any) => getters.OrderedBranchConnections(branchId).map((connection: any) => ({ ...connection.integration, connection })),
    OrderedBranchDeliveryIntegrations: (state: any, getters: any) => (branchId?: any) => getters.OrderedBranchIntegrations(branchId).filter((integration: any) => integration.category?.slug === 'delivery'),
    enabledPOSIntegration: (state: any, getters: any) => {
      const { connections } = getters
      return connections.find((connection: any) => !connection.disabled && connection?.integration?.category?.slug === 'pos')
    },
    vendorIntegrations: (state: any, getters: any) => getters.integrations.filter((integration: any) => integration.category?.slug === 'vendor'),
    allVendorsIntegrations: (state: any) => state.allVendorsIntegrations,
    activeVendorIntegrations: (state: any, getters: any) => getters.vendorIntegrations.filter((integration: any) => {
      const vendor = integration?.connection?.vendor ?? {}
      const shouldBeAccepted = ['myfatoorah', 'hybrid'].includes(vendor.type)
      return (shouldBeAccepted ? [2] : [1, 2]).includes(vendor.status)
    }) ?? [],
    activeVendorIntegration: (state: any, getters: any) => getters.activeVendorIntegrations[0]?.connection?.vendor ?? {},
    allPaymentMethods: (state: any, getters: any) => [...(new Set(getters.activeVendorIntegrations.reduce((prev: any, integration: any) => prev.concat(integration?.supported_methods ?? []), [])))],
    currentPaymentMethods: (state: any, getters: any, rootState: any, rootGetters: any) => (rootGetters['branches/currentBranch']?.payment_methods ?? []),
  },
  mutations: {
    SET_VENDORS_INTEGRATIONS(state: any, vendors: any) {
      state.allVendorsIntegrations = vendors
    },
    SET_INTEGRATIONS_CATEGORIES(state: any, categories: any) {
      state.categories = categories
      state.categoriesFetched = true
    },
    SET_CUSTOM_WHATSAPP_SETTINGS(state: any, settings: any) {
      state.customWp = settings
      state.customWpFetched = true
    },
  },
  actions: {
    async GET_VENDORS_INTEGRATIONS(context: any) {
      if (context.state.allVendorsIntegrationsFetched) return context.state.allVendorsIntegrations
      const vendors = await IntegrationsAPI.getVendorsIntegrations()
      context.commit('SET_VENDORS_INTEGRATIONS', vendors)
      return vendors
    },
    async GET_INTEGRATIONS_CATEGORIES(context: any) {
      if (context.state.categoriesFetched) return context.state.categories
      const categories = (await IntegrationCategoriesAPI.list())?.integration_categories ?? []
      context.commit('SET_INTEGRATIONS_CATEGORIES', categories)
      return categories
    },
    async GET_CUSTOM_WP_SETTINGS(context: any) {
      if (context.state.customWpFetched) return context.state.customWp
      const settings = (await CustomWhatsAppAPI.get())?.settings ?? {}
      context.commit('SET_CUSTOM_WHATSAPP_SETTINGS', settings)
      return settings
    },
  },
}
